import { render, staticRenderFns } from "./quiz-instruction.html?vue&type=template&id=7a57823c&scoped=true&"
import script from "./quiz-instruction.js?vue&type=script&lang=js&"
export * from "./quiz-instruction.js?vue&type=script&lang=js&"
import style0 from "./quiz-instruction.css?vue&type=style&index=0&id=7a57823c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a57823c",
  null
  
)

export default component.exports